import { useState } from 'react';
import automobyApi from '../Api';

export const useAuctionFee = () => {
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetch = async () => {
    try {
      setIsLoading(true);
      const response = await automobyApi.post('/auction-fee/list');
      setItems(response.data.fees || []);
    } catch (error) {
      console.error('Failed to load auction fees', error);
    } finally {
      setIsLoading(false);
    }
  };

  const add = async (payload) => {
    try {
      await automobyApi.post('/auction-fee/create', payload);
      await fetch();
    } catch (error) {
      console.error('Failed to create auction fee', error);
      throw error;
    }
  };

  const update = async (payload) => {
    try {
      await automobyApi.post('/auction-fee/update', payload);
      await fetch();
    } catch (error) {
      console.error('Failed to update auction fee', error);
      throw error;
    }
  };

  const remove = async (id) => {
    try {
      await automobyApi.post('/auction-fee/delete', { auction_fee_id: id });
      await fetch();
    } catch (error) {
      console.error('Failed to delete auction fee', error);
      throw error;
    }
  };

  const auctionFeeService = {
    items,
    isLoading,
    fetch,
    add,
    update,
    remove,
  };

  return { auctionFeeService };
};
